import axios from 'axios'
import { ROLE_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getAll() {
    return axios.get(ROLE_URL, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/role.js